import { shippingClient } from 'domain/HttpClients';
import { UPLOAD_URL } from './constants';

export const upload = (formData) => shippingClient
  .Post(UPLOAD_URL)
  .withData(formData)
  .send();
